// extracted by mini-css-extract-plugin
export var bodySections = "_cj-8";
export var gray = "_cj-7";
export var green = "_cj-4";
export var iconContainer = "_cj-9";
export var iconWidgetContainer = "_cj-1";
export var phoneIcon = "_cj-2";
export var red = "_cj-5";
export var statusDot = "_cj-3";
export var widgetContainer = "_cj-0";
export var yellow = "_cj-6";